var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconValuable48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2589_11201)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4053 6.50293H23.9619H33.5185C34.6228 6.50293 35.6656 7.01126 36.3459 7.88114L42.4544 15.6923C43.4554 16.9724 43.4716 18.7652 42.4938 20.0631L26.8437 40.8369C25.651 42.4202 23.4005 42.7368 21.8172 41.544C21.5505 41.343 21.3131 41.1059 21.112 40.8393L5.43327 20.0636C4.45375 18.7657 4.46918 16.9714 5.47088 15.6905L11.5779 7.88114C12.2582 7.01126 13.301 6.50293 14.4053 6.50293Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9902 18.1465H43.4446L26.3995 41.3033L23.9995 42.5033L25.1995 38.9033L31.9902 18.1465Z",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4053 6.50293H23.9619H33.5185C34.6228 6.50293 35.6656 7.01126 36.3459 7.88114L42.4544 15.6923C43.4554 16.9724 43.4716 18.7652 42.4938 20.0631L26.8437 40.8369C25.651 42.4202 23.4005 42.7368 21.8172 41.544C21.5505 41.343 21.3131 41.1059 21.112 40.8393L5.43327 20.0636C4.45375 18.7657 4.46918 16.9714 5.47088 15.6905L11.5779 7.88114C12.2582 7.01126 13.301 6.50293 14.4053 6.50293Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5909 6.83389L30.9882 16.1531C31.6203 17.0738 31.7878 18.2363 31.4413 19.298L23.9623 42.2162L16.4833 19.298C16.1368 18.2363 16.3043 17.0738 16.9363 16.1531L23.3337 6.83389C23.4759 6.62673 23.711 6.50293 23.9623 6.50293C24.2136 6.50293 24.4487 6.62673 24.5909 6.83389Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.89404 17.7197H43.0301",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_11201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconValuable48);
export default __webpack_public_path__ + "static/media/pictogramBeaconValuable48.11c9494aaf5beced40b2a0826e0df9aa.svg";
export { ForwardRef as ReactComponent };